import React, { FC } from 'react'
import { capitalize } from '../../helpers/helpers'
import { getTypeColor, PokemonType } from '../../helpers/types'
import ArrowBoost from '../../images/icons/arrow-boost'

import Box, { BoxProps } from '../box'
import Text from '../text'
import PokemonTypeIcon from './pokemon-type-icon'

interface Props extends BoxProps {
  type: PokemonType
  multiplier?: number
  onlyShowIcon?: boolean
  darken?: boolean
  isBoosted?: boolean
}

const TypeTag: FC<Props> = ({ type, multiplier, onlyShowIcon, darken, isBoosted, ...rest }) => {
  const color = getTypeColor(type)
  return (
    <Box
      py={onlyShowIcon ? 2 : 2}
      px={onlyShowIcon ? 2 : 3}
      color="white"
      borderRadius={onlyShowIcon ? '100%' : 'small'}
      borderColor={color}
      backgroundColor={color}
      display="flex"
      alignItems="stretch"
      position="relative"
      overflow="hidden"
      {...rest}
    >
      <Box display="flex" alignItems="center">
        <PokemonTypeIcon fill="white" type={type} height={onlyShowIcon ? '14px' : '12px'} />
      </Box>
      {!onlyShowIcon && (
        <Text fontSize={2} m={0} ml={2} fontWeight="bold">
          {capitalize(type)}
        </Text>
      )}
      {!onlyShowIcon && multiplier && (
        <Box
          backgroundColor="rgba(0, 0, 0, .175)"
          my={-2}
          mr={-3}
          ml={3}
          pl={2}
          pr={2}
          display="flex"
          alignItems="center"
        >
          <Text fontSize={2} m={0} fontWeight="bold" lineHeight="1">
            {multiplier < 1 ? '.' + multiplier.toString().split('.')[1] : multiplier}x
          </Text>
        </Box>
      )}
      {isBoosted && (
        <Box position="absolute" top="-13px" right="-4px">
          <ArrowBoost fill="black" height="12px" />
        </Box>
      )}
    </Box>
  )
}

export default TypeTag
